/* eslint-disable no-param-reassign,@typescript-eslint/no-unused-expressions,@typescript-eslint/no-unused-vars */

import { EVENTS } from '../../../../app/constants/events';
import { updateComponent } from '../../../../app/package-designer/store/component.actions';
import { loadSelectPickerItems } from '../../../../app/common/store/select-picker.actions';
import { queryParamsMap } from '../../../../app/common/components/forms/select-picker/select-picker-types.enum';

xplenty.directive('salesforceDestinationEditor', [
  '$timeout',
  '$rootScope',
  '$translate',
  'selectPickerModal',
  function ($timeout, $rootScope, $translate, selectPickerModal) {
    return {
      restrict: 'E',

      // eslint-disable-next-line global-require
      template: require('./salesforce-destination-editor.html'),

      replace: true,

      scope: false,

      controller: [
        '$scope',
        'ngrxStoreService',

        function ($scope, ngrxStoreService) {
          $scope.schemas = [];
          $scope.idOptions = [];
          $scope.schemaReady = false;
          $scope.areFieldsLoading = false;
          $scope.schemaMappingStep.lock = true;
          $scope.records = angular.copy($scope.component.column_mappings);
          $scope.errorsOutputConnectionQuery = {
            type: 's3,gs,sftp,ftps,azureblobstorage',
          };

          $scope.operationTypes = [
            {
              value: 'insert',
              text: 'salesforce-destination-editor.form.operation-type.option.insert',
              translate: true,
            },
            {
              value: 'upsert',
              text: 'salesforce-destination-editor.form.operation-type.option.upsert',
              translate: true,
            },
            {
              value: 'update',
              text: 'salesforce-destination-editor.form.operation-type.option.update',
              translate: true,
            },
            {
              value: 'delete',
              text: 'salesforce-destination-editor.form.operation-type.option.delete',
              translate: true,
            },
          ];

          $scope.onColumnMappingsChange = (records) => {
            $scope.component.column_mappings = records;
          };

          $scope.onTrackErrorsChange = ({ track_errors }) => {
            ngrxStoreService.dispatch(updateComponent({ component: { track_errors } }));
          };

          $scope.onNullFieldsChange = ({ enable_null_value }) => {
            ngrxStoreService.dispatch(updateComponent({ component: { enable_null_value } }));
          };

          $scope.selectErrorsOutputConnection = function (connection) {
            $scope.component.errors_output_connection = connection;
          };

          $scope.onUpdateConnection = ({ connectionType, type }) => {
            selectPickerModal.createNew(connectionType, type);

            const subscriber = $rootScope.$on(EVENTS.CONNECTION_UPDATED, () => {
              ngrxStoreService.dispatch(
                loadSelectPickerItems({
                  itemType: type,
                  params: { ...queryParamsMap[type], ...$scope.errorsOutputConnectionQuery },
                }),
              );
              subscriber();
            });
          };

          $scope.onSchemaValidityChange = (isValid) => {
            $scope.collectionValid = isValid;

            const schemaMappingValid = $scope.collectionValid && !$scope.loadingFields;

            if (schemaMappingValid) {
              $scope.schemaMappingStep.tags = _.map($scope.records, function (record) {
                return {
                  name: _.escape(record.column_name),
                };
              });
            } else {
              $scope.schemaMappingStep.tags = [];
            }

            $scope.schemaMappingStep.error = !$scope.collectionValid;
            $scope.schemaMappingStep.valid = schemaMappingValid;

            return schemaMappingValid;
          };

          $scope.onOperationTypeChange = (operationType) => {
            $scope.component.operation_type = operationType;
            if (operationType !== 'upsert' && operationType !== 'update') {
              $scope.component.id_field = null;
            }
          };

          $scope.onIdFieldChange = (idField) => {
            $scope.component.id_field = idField;
            $scope.idFieldErrorMsg = null;
          };

          $scope.$on(EVENTS.SALESFORCE_OBJECT_PICKER_FIELDS_LOAD_START, function () {
            $scope.schemaReady = false;
            $scope.schemaMappingStep.loading = true;
            $scope.schemaMappingStep.lock = false;
            $scope.areFieldsLoading = true;
          });

          const checkUpsertKey = function (fields) {
            if (
              ($scope.component.operation_type === 'upsert' || $scope.component.operation_type === 'update') &&
              $scope.component.id_field
            ) {
              const upsertKeyRecord = _.find(fields, { name: $scope.component.id_field });
              if (!upsertKeyRecord) {
                $scope.idFieldErrorMsg = $translate.instant('salesforce-destination-editor.form.errors.id_field', {
                  field: $scope.component.id_field,
                });
                // $scope.idFieldErrorMsg = 'Upsert key "' + _.escape($scope.component.id_field) + '" does not exist in schema. Please choose a different key';
                $scope.component.id_field = '';
                $timeout(function () {
                  $scope.componentForm.id_field && $scope.componentForm.id_field.$setDirty();
                });
              }
            }
          };

          $scope.$on(EVENTS.SALESFORCE_OBJECT_PICKER_FIELDS_LOADED, function (event, fields) {
            const destinationSchema = {};

            destinationSchema.id = 'salesforce_fields';
            destinationSchema.name = 'salesforce_fields';
            destinationSchema.fields = [];

            $scope.idOptions = [];

            _.each(fields, function (field) {
              destinationSchema.fields.push({
                name: field.name,
              });
              if (field && field.is_keyable) {
                $scope.idOptions.push({ text: field.name, value: field.name });
              }
            });

            const schemas = [$scope.parentSchemas[0], destinationSchema];

            $scope.schemas = schemas;
            $scope.fields = fields;

            $scope.schemaReady = true;
            $scope.schemaMappingStep.lock = false;
            $scope.schemaMappingStep.loading = false;

            checkUpsertKey(fields);

            $scope.areFieldsLoading = false;
          });
        },
      ],
    };
  },
]);
